var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.633301,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#4C65ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10533 13.2374L7.08771 13.255L2.68787 8.85515L4.12054 7.42247L7.10539 10.4073L11.8794 5.6333L13.3121 7.06598L7.12301 13.2551L7.10533 13.2374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.bea60ddf8bdff9f2b0a234cfe1602b63.svg";
export { ForwardRef as ReactComponent };